exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ButtonWrap__root___2M4VX {\n  display: inline-block;\n  position: relative;\n  /* This ensures the popover will show on top of the editor. */\n  z-index: 10;\n}\n", ""]);

// Exports
exports.locals = {
	"root": "ButtonWrap__root___2M4VX"
};


//////////////////
// WEBPACK FOOTER
// ../css-loader/dist/cjs.js??ref--2-1!../react-rte/lib/ui/ButtonWrap.css
// module id = 2150
// module chunks = 25